import HotWorkConditionsRequest from "../../../requests/HotWorkRequest";
import FormElement, { formElement } from "../../FormElement";

type HotWorkConditionsFormState = {
    isPhoneClassified: FormElement<boolean>;
    isGasDeclared: FormElement<boolean>;
    isContinousGasMeasurements: FormElement<boolean>;
    isSparkProtected: FormElement<boolean>;
    isWellsProtected: FormElement<boolean>;
    isCleanedUpForFireProtection: FormElement<boolean>;
    workPlaceMonitoredIsChecked: FormElement<boolean>;
    fireGuardCount: FormElement<string>;
    postWorkPlaceMonitoredHours: FormElement<string>;
    fireDetectorsTurnedOffIsChecked: FormElement<boolean>;
    fireDetectorsTurnedOffSectionNames: FormElement<string | undefined>;
    isWaterFromFirePostInPlace: FormElement<boolean>;
    fireExtinguisherIsChecked: FormElement<boolean>;
    fireExtinguisherCount: FormElement<number | undefined>;
    fireExtinguisherKg: FormElement<number | undefined>;
    noHotworkWithFlammableMaterialsUsedSub30Celcius: FormElement<boolean>;
    distanceFromPumpsAndVentilationMeters: FormElement<number>;
    noHotWorkCloseToShipsHandlingFlammables: FormElement<boolean>;
    noHotWorkAtQuay: FormElement<boolean>;
    isShipInformedAboutFlammablesSub30Celcius: FormElement<boolean>;
    isCloseDepotInformedBeforeWorkIsStarted: FormElement<boolean>;
    informCloseDepotBeforeWorkIsChecked: FormElement<boolean>;

    nameOfCloseDepotBeforeWorkIsStartedInfo: FormElement<string | undefined>;
    otherInformation: FormElement<string | undefined>;
};

export default HotWorkConditionsFormState;

export function HotWorkFormState_toRequest(formState: HotWorkConditionsFormState): HotWorkConditionsRequest {
    const request: HotWorkConditionsRequest = {
        isPhoneClassified: formState.isPhoneClassified.value,
        isGasDeclared: formState.isGasDeclared.value,
        isContinousGasMeasurements: formState.isContinousGasMeasurements.value,
        isSparkProtected: formState.isSparkProtected.value,
        isWellsProtected: formState.isWellsProtected.value,
        isCleanedUpForFireProtection: formState.isCleanedUpForFireProtection.value,
        workPlaceMonitoredIsChecked: formState.workPlaceMonitoredIsChecked.value,
        fireGuardCount: formState.fireGuardCount.value,
        postWorkPlaceMonitoredHours: formState.postWorkPlaceMonitoredHours.value,
        fireDetectorsTurnedOffIsChecked: formState.fireDetectorsTurnedOffIsChecked.value,
        fireDetectorsTurnedOffSectionNames: formState.fireDetectorsTurnedOffSectionNames.value,
        isWaterFromFirePostInPlace: formState.isWaterFromFirePostInPlace.value,
        fireExtinguisherIsChecked: formState.fireExtinguisherIsChecked.value,
        fireExtinguisherCount: formState.fireExtinguisherCount.value,
        fireExtinguisherKg: formState.fireExtinguisherKg.value,
        noHotworkWithFlammableMaterialsUsedSub30Celcius:
            formState.noHotworkWithFlammableMaterialsUsedSub30Celcius.value,
        distanceFromPumpsAndVentilationMeters: formState.distanceFromPumpsAndVentilationMeters.value,
        noHotWorkCloseToShipsHandlingFlammables: formState.noHotWorkCloseToShipsHandlingFlammables.value,
        noHotWorkAtQuay: formState.noHotWorkAtQuay.value,
        isShipInformedAboutFlammablesSub30Celcius: formState.isShipInformedAboutFlammablesSub30Celcius.value,
        isCloseDepotInformedBeforeWorkIsStarted: formState.isCloseDepotInformedBeforeWorkIsStarted.value,
        informCloseDepotBeforeWorkIsChecked: formState.informCloseDepotBeforeWorkIsChecked.value,
        nameOfCloseDepotBeforeWorkIsStartedInfo: formState.nameOfCloseDepotBeforeWorkIsStartedInfo.value,
        otherInformation: formState.otherInformation.value
    };

    return request;
}

export function HotWorkFormState_defaultHotWorkCatOneConditions(): HotWorkConditionsFormState {
    return {
        isPhoneClassified: formElement(true),
        isCleanedUpForFireProtection: formElement(true),
        isGasDeclared: formElement(false),
        isContinousGasMeasurements: formElement(true),
        isSparkProtected: formElement(true),
        isWellsProtected: formElement(true),
        fireExtinguisherCount: formElement(2),
        fireExtinguisherKg: formElement(12),
        fireExtinguisherIsChecked: formElement(true),
        isWaterFromFirePostInPlace: formElement(true),
        fireGuardCount: formElement("1"),
        postWorkPlaceMonitoredHours: formElement("1"),
        workPlaceMonitoredIsChecked: formElement(true),
        fireDetectorsTurnedOffIsChecked: formElement(false),
        fireDetectorsTurnedOffSectionNames: formElement(""),
        noHotworkWithFlammableMaterialsUsedSub30Celcius: formElement(true),
        distanceFromPumpsAndVentilationMeters: formElement(25),
        noHotWorkAtQuay: formElement(false),
        isShipInformedAboutFlammablesSub30Celcius: formElement(false),
        noHotWorkCloseToShipsHandlingFlammables: formElement(false),
        otherInformation: formElement(""),
        informCloseDepotBeforeWorkIsChecked: formElement(false),
        nameOfCloseDepotBeforeWorkIsStartedInfo: formElement(""),
        isCloseDepotInformedBeforeWorkIsStarted: formElement(false)
    };
}

export function HotWorkFormState_defaultHotWorkCatTwoConditions(): HotWorkConditionsFormState {
    return {
        isPhoneClassified: formElement(true),
        isCleanedUpForFireProtection: formElement(true),
        isGasDeclared: formElement(false),
        isContinousGasMeasurements: formElement(true),
        isSparkProtected: formElement(false),
        isWellsProtected: formElement(false),
        fireExtinguisherCount: formElement(2),
        fireExtinguisherKg: formElement(12),
        fireExtinguisherIsChecked: formElement(true),
        isWaterFromFirePostInPlace: formElement(false),
        fireGuardCount: formElement(""),
        postWorkPlaceMonitoredHours: formElement(""),
        workPlaceMonitoredIsChecked: formElement(false),
        fireDetectorsTurnedOffIsChecked: formElement(false),
        fireDetectorsTurnedOffSectionNames: formElement(""),
        noHotworkWithFlammableMaterialsUsedSub30Celcius: formElement(true),
        distanceFromPumpsAndVentilationMeters: formElement(15),
        noHotWorkAtQuay: formElement(false),
        isShipInformedAboutFlammablesSub30Celcius: formElement(false),
        noHotWorkCloseToShipsHandlingFlammables: formElement(false),
        otherInformation: formElement(""),
        informCloseDepotBeforeWorkIsChecked: formElement(false),
        nameOfCloseDepotBeforeWorkIsStartedInfo: formElement(""),
        isCloseDepotInformedBeforeWorkIsStarted: formElement(false)
    };
}

export function HotWorkFormState_defaultHotWorkCatThreeConditions(): HotWorkConditionsFormState {
    return {
        isPhoneClassified: formElement(true),
        isCleanedUpForFireProtection: formElement(true),
        isGasDeclared: formElement(false),
        isContinousGasMeasurements: formElement(true),
        isSparkProtected: formElement(false),
        isWellsProtected: formElement(false),
        fireExtinguisherCount: formElement(2),
        fireExtinguisherKg: formElement(12),
        fireExtinguisherIsChecked: formElement(true),
        isWaterFromFirePostInPlace: formElement(false),
        fireGuardCount: formElement(""),
        postWorkPlaceMonitoredHours: formElement(""),
        workPlaceMonitoredIsChecked: formElement(false),
        fireDetectorsTurnedOffIsChecked: formElement(false),
        fireDetectorsTurnedOffSectionNames: formElement(""),
        noHotworkWithFlammableMaterialsUsedSub30Celcius: formElement(true),
        distanceFromPumpsAndVentilationMeters: formElement(15),
        noHotWorkAtQuay: formElement(false),
        isShipInformedAboutFlammablesSub30Celcius: formElement(false),
        noHotWorkCloseToShipsHandlingFlammables: formElement(false),
        otherInformation: formElement(""),
        informCloseDepotBeforeWorkIsChecked: formElement(false),
        nameOfCloseDepotBeforeWorkIsStartedInfo: formElement(""),
        isCloseDepotInformedBeforeWorkIsStarted: formElement(false)
    };
}
